import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'

import { Seo } from '@/components/generals/seo'
import { AuthLayout } from '@/components/auth/auth-layout'
import { LoginForm } from '@/components/auth/auth-forms'
import { getSessionAccount } from '@/lib/auth'

const Login: FC = (): ReactNode => {
    return (
        <>
            <Seo title='Log in' description='Log in to your Veyra workspace.' />

            <AuthLayout
                title='Welcome back.'
                description='Log in to your workspace to pick up where you left off.'
            >
                <LoginForm />
            </AuthLayout>
        </>
    )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
    try {
        const account = await getSessionAccount(req)

        if (account) return { redirect: { destination: '/app', permanent: false } }
    }
    catch (error) {
        console.error('Could not check the session:', error instanceof Error ? error.message : error)
    }

    return { props: {} }
}

export default Login
